import Vue from 'vue'
import Router from 'vue-router'
// import Main from '@/components/main'
// import ProjectList from '@/components/project/project-list'
// import Me from '@/components/user/me'
// import Login from '@/components/user/login'
// import Version from '@/components/user/version-explain'
// import ModifyPassword from '@/components/user/modify-password'
// import AddProject from '@/components/project/add-project'
// import ProjectView from '@/components/project/project-view'
// import DeviceMain from '@/components/device/device-main'
// import StrategyInfor from '@/components/strategy/strategy-infor'
// import GroupInfor from '@/components/group/group-infor'
// import GroupView from '@/components/group/group-view'
// import ProjectBriefDevices from '@/components/group/project-brief-devices'
// import SwicthStrategy from '@/components/strategy/swicth-strategy'
// import ProjectTag from '@/components/project/project-tag'
// import AddDevice from '@/components/device/add-device'
const Main = () => import('../components/main')
const ProjectList = () => import('../components/project/project-list')
const Me = () => import('../components/user/me')
const Login = () => import('../components/user/login')
const Version = () => import('../components/user/version-explain')
const ModifyPassword = () => import('../components/user/modify-password')
const AddProject = () => import('../components/project/add-project')
const ProjectView = () => import('../components/project/project-view')
const DeviceMain = () => import('../components/device/device-main')
const StrategyInfor = () => import('../components/strategy/strategy-infor')
const StrategyInfor8 = () => import('../components/strategy/strategy-infor8')
const GroupInfor = () => import('../components/group/group-infor')
const GroupView = () => import('../components/group/group-view')
const ProjectBriefDevices = () => import('../components/group/project-brief-devices')
const SwicthStrategy = () => import('../components/strategy/swicth-strategy')
const ProjectTag = () => import('../components/project/project-tag')
const AddDevice = () => import('../components/device/add-device')
const DeviceLive = () => import('../components/device/device-live')

const SensorDetail = () => import('@/views/sensor/sensor-detail')
const SensorChart = () => import('@/views/sensor/sensor-chart')

const DtuMain = () => import('@/views/dtu/index.vue')
const DtuChart = () => import('@/views/dtu/chart/index.vue')
const DtuChartAggregation = () => import('@/views/dtu/chart/aggregation.vue')

const ChargePileList = () => import('@/views/charge-pile/list.vue')
const ChargePileDetail = () => import('@/views/charge-pile/detail.vue')

Vue.use(Router)

export default new Router({
  mode: 'history',
  routes: [
    {
      path: '/',
      name: 'Main',
      component: Main,
      redirect: '/ProjectList',
      children: [
        {
          path: '/ProjectList',
          name: 'ProjectList',
          component: ProjectList,
          keepAlive: true
        },
        {
          path: '/me',
          name: 'me',
          component: Me
        }
      ]
    },
    {
      path: '/login',
      name: 'Login',
      component: Login
    },
    {
      path: '/version',
      name: 'Version',
      component: Version
    },
    {
      path: '/modify-password',
      name: 'ModifyPassword',
      component: ModifyPassword
    },
    {
      path: '/add-project',
      name: 'AddProject',
      component: AddProject
    },
    {
      path: '/project-view',
      name: 'ProjectView',
      component: ProjectView
    },
    {
      path: '/device-main',
      name: 'DeviceMain',
      component: DeviceMain
    },
    {
      path: '/strategy-infor',
      name: 'StrategyInfor',
      component: StrategyInfor
    },
    {
      path: '/strategy-infor8',
      name: 'StrategyInfor8',
      component: StrategyInfor8
    },
    {
      path: '/group-infor',
      name: 'GroupInfor',
      component: GroupInfor
    },
    {
      path: '/group-view',
      name: 'GroupView',
      component: GroupView
    },
    {
      path: '/project-brief-devices',
      name: 'ProjectBriefDevices',
      component: ProjectBriefDevices
    },
    {
      path: '/swicth-strategy',
      name: 'SwicthStrategy',
      component: SwicthStrategy
    },
    {
      path: '/project-tag',
      name: 'ProjectTag',
      component: ProjectTag
    },
    {
      path: '/add-device',
      name: 'AddDevice',
      component: AddDevice
    },
    {
      path: '/device-live',
      name: 'DeviceLive',
      component: DeviceLive
    },
    {
      path: '/sensor-detail',
      name: 'SensorDetail',
      component: SensorDetail
    },
    {
      path: '/sensor-chart',
      name: 'SensorChart',
      component: SensorChart
    },
    {
      path: '/dtu-main',
      name: 'DtuMain',
      component: DtuMain
    },
    {
      path: '/dtu-chart',
      name: 'DtuChart',
      component: DtuChart
    },
    {
      path: '/dtu-aggregation-chart',
      name: 'DtuChartAggregation',
      component: DtuChartAggregation
    },
    {
      path: '/charge-pile/list',
      name: 'ChargePileList',
      component: ChargePileList
    },
    {
      path: '/charge-pile/detail',
      name: 'ChargePileDetail',
      component: ChargePileDetail
    }
  ]
})
